module.exports = __webpack_public_path__ + "img/icon-user.0b48eae5.svg";